export enum AppNameEnum {
  UME = 'Ume',
  ODRES_CRED = 'Odres Cred',
}
